export function validateHotsiteConfiguration(configuration) {
  const errors = {
    tabs: {},
    fields: {},
  }

  // Validate colors (tab 0)
  const colorErrors = []
  if (configuration?.settings?.assets?.colors) {
    const colors = configuration.settings.assets.colors

    // Check all color sections
    const colorSections = ['home', 'form', 'finish', 'legalFooter', 'socialNetworksFooter']
    colorSections.forEach((section) => {
      if (colors[section]) {
        Object.entries(colors[section]).forEach(([field, value]) => {
          if (!value || value.trim() === '') {
            colorErrors.push(`${section}.${field}`)
            errors.fields[`colors.${section}.${field}`] = 'Campo obrigatório'
          }
        })
      }
    })
  }

  if (colorErrors.length > 0) {
    errors.tabs[0] = colorErrors
  }

  // Validate images (tab 1)
  const imageErrors = []
  if (configuration?.settings?.assets?.images) {
    const images = configuration.settings.assets.images

    // Check all image sections
    const imageSections = ['home', 'form']
    imageSections.forEach((section) => {
      if (images[section]) {
        Object.entries(images[section]).forEach(([device, value]) => {
          if (!value) {
            imageErrors.push(`${section}.${device}`)
            errors.fields[`images.${section}.${device}`] = 'Campo obrigatório'
          }
        })
      }
    })

    if (!images?.finish?.logo) {
      imageErrors.push('finish.logo')
      errors.fields[`images.finish.logo`] = 'Campo obrigatório'
    }
  }

  if (imageErrors.length > 0) {
    errors.tabs[1] = imageErrors
  }

  return errors
}
